import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { MoreHoriz } from '@mui/icons-material';
import WhatsApp from '../../../../assets/icons/social-media/whatsapp.svg';
import Instagram from '../../../../assets/icons/social-media/instagram.svg';
import Facebook from '../../../../assets/icons/social-media/facebook.svg';
import Mobile from '../../../../assets/icons/social-media/mobile.svg';
import { isMobile } from 'react-device-detect';
import { redirecTo, openNewTabAndFocus } from '../../../../utils';
import l from '../../../../lang';
import './styles.scss';
import { Tooltip } from '../../../common/tooltip';
import {
  segmentPaymentLinkLinkBoxShareMobile,
  segmentPaymentLinkLinkBoxShareWhatsApp,
  segmentPaymentLinkShareFacebook,
} from '../../../../utils/analytics';

const ShareButtons = ({ link }) => {
  const onWhatsAppHandler = () => {
    segmentPaymentLinkLinkBoxShareWhatsApp();
    if (isMobile) {
      redirecTo(`https://wa.me/?text=${l('paymentLink.shareLink')} ${link}`);
    } else {
      openNewTabAndFocus(`https://web.whatsapp.com/send?text=${l('paymentLink.shareLink')} ${link}`);
    }
  };

  const onFacebookHandler = () => {
    segmentPaymentLinkShareFacebook();
    openNewTabAndFocus(`http://www.facebook.com/sharer/sharer.php?u=${link}`);
  };

  const onMobileHandler = () => {
    segmentPaymentLinkLinkBoxShareMobile();
    navigator
      .share({
        title: l('paymentLink.shareLink'),
        url: `${link}`,
      })
      .then(() => { })
      .catch(err => { });
  };

  return (
    <div className="share-buttons">
      <div className="payment-link__share__subheadline">{l('paymentLink.shareLink.subheadline2')}</div>
      <div className="share-buttons__content">
        <div className="share-buttons__buton">
          <Tooltip title="Whatsapp">
            <IconButton onClick={onWhatsAppHandler}>
              <img src={WhatsApp} />
            </IconButton>
          </Tooltip>
        </div>
        <div className="share-buttons__buton">
          <Tooltip title="Facebook">
            <IconButton onClick={onFacebookHandler}>
              <img src={Facebook} />
            </IconButton>
          </Tooltip>
        </div>
        {navigator.share && (
          <div className="share-buttons__buton">
            <IconButton onClick={onMobileHandler}>
              <img src={Mobile} />
            </IconButton>
            <div className="share-buttons__desc">{l('paymentLink.shareLink.moreOptions')}</div>
          </div>
        )}
      </div>
    </div>
  );
};

ShareButtons.propTypes = {
  link: PropTypes.string,
};

export default ShareButtons;
